import { useRef, useState, useCallback } from "react";

const BASE_URL = "https://regovix-twincore-dev.netlify.app";
const PASS = "twincore1978";
const SESSION_KEY = "clone_access";

const S = {
  bg: "#070B12", panel: "#0D1321", card: "#111927", border: "#1A2540",
  cyan: "#00C9FF", mint: "#00FFB2", red: "#FF4560", text: "#DDE6F5", muted: "#5A6A8A",
  cyanDim: "rgba(0,201,255,0.1)", cyanBorder: "rgba(0,201,255,0.25)",
  mintDim: "rgba(0,255,178,0.1)", mintBorder: "rgba(0,255,178,0.22)",
  purple: "#A855F7", purpleDim: "rgba(168,85,247,0.1)", purpleBorder: "rgba(168,85,247,0.25)",
};

function Gate({ onUnlock }) {
  const [tab, setTab] = useState("login");
  const [pass, setPass] = useState("");
  const [error, setError] = useState(false);
  const [name, setName] = useState("");
  const [company, setCompany] = useState("");
  const [email, setEmail] = useState("");
  const [useCase, setUseCase] = useState("");
  const [sent, setSent] = useState(false);

  const checkPass = () => {
    const input = pass.trim().toLowerCase().replace(/\s+/g, "");
    if (input === PASS.replace(/\s+/g, "")) {
      sessionStorage.setItem(SESSION_KEY, "1");
      onUnlock();
    } else {
      setError(true);
      setPass("");
    }
  };

  const submitRequest = () => {
    if (!name || !email) { alert("Please enter your name and email."); return; }
    const subject = encodeURIComponent("Clone Yourself Demo Request — " + company);
    const body = encodeURIComponent("Name: " + name + "\nCompany: " + company + "\nEmail: " + email + "\nUse Case: " + useCase);
    window.location.href = "mailto:maddypat@regovix.com.au?subject=" + subject + "&body=" + body;
    setSent(true);
  };

  const inputStyle = { width: "100%", background: S.bg, border: "1px solid " + S.border, borderRadius: "8px", padding: "12px 16px", color: S.text, fontSize: "14px", fontFamily: "inherit", outline: "none", marginBottom: "10px" };
  const btnPrimary = { width: "100%", padding: "12px", borderRadius: "8px", fontSize: "14px", fontWeight: 600, cursor: "pointer", border: "none", fontFamily: "inherit", background: S.purple, color: "#fff", marginBottom: "8px" };
  const btnOutline = { width: "100%", padding: "12px", borderRadius: "8px", fontSize: "14px", fontWeight: 600, cursor: "pointer", fontFamily: "inherit", background: "none", border: "1px solid " + S.border, color: S.muted };

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(7,11,18,0.97)", zIndex: 500, display: "flex", alignItems: "center", justifyContent: "center", padding: "24px" }}>
      <div style={{ background: S.card, border: "1px solid " + S.border, borderRadius: "16px", padding: "40px", maxWidth: "420px", width: "100%", textAlign: "center" }}>
        <div style={{ fontSize: "48px", marginBottom: "16px" }}>🧬</div>
        <div style={{ fontFamily: "'Syne',sans-serif", fontSize: "24px", fontWeight: 800, marginBottom: "8px" }}>Clone Yourself</div>
        <div style={{ fontSize: "13px", color: S.muted, marginBottom: "24px", lineHeight: 1.7 }}>
          AI-powered video digital twin by Regovix.<br />Enter your access code or request a demo.
        </div>

        <div style={{ display: "flex", gap: "8px", marginBottom: "20px" }}>
          {["login", "request"].map((t, i) => (
            <button key={t} onClick={() => setTab(t)} style={{ flex: 1, padding: "10px", borderRadius: "8px", border: "1px solid " + (tab === t ? S.purple : S.border), background: tab === t ? S.purple : "none", color: tab === t ? "#fff" : S.muted, fontFamily: "inherit", fontSize: "13px", fontWeight: 600, cursor: "pointer" }}>
              {i === 0 ? "Enter Code" : "Request Access"}
            </button>
          ))}
        </div>

        {tab === "login" && (
          <div>
            <input type="password" value={pass} onChange={e => { setPass(e.target.value); setError(false); }}
              onKeyDown={e => e.key === "Enter" && checkPass()}
              placeholder="Enter access code" style={{ ...inputStyle, textAlign: "center", letterSpacing: "3px" }} />
            {error && <div style={{ color: S.red, fontSize: "13px", marginBottom: "10px" }}>Incorrect code. Please try again or request access.</div>}
            <button onClick={checkPass} style={btnPrimary}>Access Clone Yourself →</button>
            <button onClick={() => setTab("request")} style={btnOutline}>Request Demo Access</button>
          </div>
        )}

        {tab === "request" && (
          <div>
            {[
              { label: "Full Name *", val: name, set: setName, ph: "Your name" },
              { label: "Company", val: company, set: setCompany, ph: "Company name" },
              { label: "Email *", val: email, set: setEmail, ph: "your@email.com" },
              { label: "Use Case", val: useCase, set: setUseCase, ph: "e.g. HSEQ advisor, consultant" },
            ].map(f => (
              <div key={f.label} style={{ textAlign: "left", marginBottom: "8px" }}>
                <div style={{ fontSize: "11px", color: S.muted, fontFamily: "monospace", marginBottom: "4px" }}>{f.label}</div>
                <input value={f.val} onChange={e => f.set(e.target.value)} placeholder={f.ph} style={inputStyle} />
              </div>
            ))}
            {sent && <div style={{ color: S.mint, fontSize: "13px", marginBottom: "10px" }}>✓ Request sent! Madhu will be in touch within 1 business day.</div>}
            <button onClick={submitRequest} style={btnPrimary}>Request Demo Access →</button>
            <button onClick={() => setTab("login")} style={{ ...btnOutline, marginTop: "4px" }}>I have an access code</button>
          </div>
        )}

        <div style={{ fontSize: "11px", color: S.muted, marginTop: "16px" }}>
          <a href="https://regovix.com.au" style={{ color: S.muted }}>regovix.com.au</a> · maddypat@regovix.com.au
        </div>
      </div>
    </div>
  );
}

function Btn({ onClick, disabled, danger, children }) {
  return (
    <button onClick={onClick} disabled={disabled} style={{
      padding: "10px 20px", borderRadius: "8px", fontSize: "13px", fontWeight: 600,
      cursor: disabled ? "not-allowed" : "pointer", width: "100%",
      border: danger ? "1px solid rgba(255,69,96,0.3)" : "1px solid " + S.purple,
      background: danger ? "rgba(255,69,96,0.1)" : S.purple,
      color: danger ? S.red : "#fff", opacity: disabled ? 0.4 : 1, fontFamily: "inherit",
    }}>{children}</button>
  );
}

function Card({ title, sub, children }) {
  return (
    <div style={{ background: S.card, border: "1px solid " + S.border, borderRadius: "12px", padding: "20px" }}>
      {title && <div style={{ fontFamily: "'Syne',sans-serif", fontSize: "14px", fontWeight: 700, marginBottom: "4px" }}>{title}</div>}
      {sub && <div style={{ fontSize: "12px", color: S.muted, marginBottom: "14px" }}>{sub}</div>}
      {children}
    </div>
  );
}

export default function App() {
  const avatarPanelRef = useRef(null);
  const iframeRef = useRef(null);
  const [unlocked, setUnlocked] = useState(sessionStorage.getItem(SESSION_KEY) === "1");
  const [status, setStatus] = useState("offline");
  const [statusText, setStatusText] = useState("Offline");
  const [isActive, setIsActive] = useState(false);
  const [query, setQuery] = useState("");
  const [chatLog, setChatLog] = useState([]);
  const [isAsking, setIsAsking] = useState(false);
  const [overlayVisible, setOverlayVisible] = useState(true);
  const [overlayContent, setOverlayContent] = useState({ icon: "🧬", title: "Clone Yourself", sub: "Click Start Session to connect your AI video clone", spinner: false });

  const updateStatus = useCallback((text, type) => { setStatusText(text); setStatus(type || "offline"); }, []);
  const appendBubble = useCallback((role, text) => setChatLog(p => [...p, { role, text, id: Date.now() + Math.random() }]), []);

  const startSession = useCallback(async () => {
    setOverlayVisible(true);
    setOverlayContent({ icon: "", title: "Connecting...", sub: "Getting embed URL from LiveAvatar...", spinner: true });
    updateStatus("Connecting...", "loading");

    try {
      const res = await fetch(BASE_URL + "/api/avatar-session", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action: "get_embed" }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Failed to get embed URL");

      // Create iframe inside avatar panel
      if (iframeRef.current) iframeRef.current.remove();
      const iframe = document.createElement("iframe");
      iframe.src = data.url;
      iframe.allow = "microphone;camera";
      iframe.style.cssText = "position:absolute;inset:0;width:100%;height:100%;border:none;z-index:3;border-radius:12px";
      avatarPanelRef.current.appendChild(iframe);
      iframeRef.current = iframe;

      setOverlayVisible(false);
      updateStatus("Connected — AI Clone Active", "active");
      setIsActive(true);

    } catch (err) {
      setOverlayContent({ icon: "!", title: "Connection Failed", sub: err.message, spinner: false });
      updateStatus("Error", "offline");
    }
  }, [updateStatus]);

  const stopSession = useCallback(() => {
    if (iframeRef.current) { iframeRef.current.remove(); iframeRef.current = null; }
    setIsActive(false);
    setOverlayVisible(true);
    setOverlayContent({ icon: "🧬", title: "Clone Yourself", sub: "Session ended. Click Start Session to reconnect.", spinner: false });
    updateStatus("Offline", "offline");
  }, [updateStatus]);

  const askQuestion = useCallback(async () => {
    if (!query.trim()) return;
    const q = query.trim();
    setQuery("");
    setIsAsking(true);
    appendBubble("user", q);
    try {
      const res = await fetch(BASE_URL + "/api/avatar-query", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ query: q }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Query failed");
      appendBubble("assistant", data.answer);
    } catch (err) {
      appendBubble("assistant", "Sorry, I encountered an issue. Please try again.");
    }
    setIsAsking(false);
  }, [query, appendBubble]);

  const logout = () => { sessionStorage.removeItem(SESSION_KEY); setUnlocked(false); };

  const statusDotColor = { active: S.mint, speaking: S.cyan, loading: "#FFB800", offline: S.muted };

  if (!unlocked) return <Gate onUnlock={() => setUnlocked(true)} />;

  return (
    <div style={{ background: S.bg, minHeight: "100vh", color: S.text, fontFamily: "'DM Sans',sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400;600&family=Syne:wght@700;800&family=DM+Sans:wght@300;400;500&display=swap');
        @keyframes pulse{0%,100%{opacity:1}50%{opacity:0.4}}
        @keyframes spin{to{transform:rotate(360deg)}}
        *{box-sizing:border-box;margin:0;padding:0}
      `}</style>

      <div style={{ background: S.panel, borderBottom: "1px solid " + S.border, padding: "0 32px", height: "56px", display: "flex", alignItems: "center", gap: "16px", position: "sticky", top: 0, zIndex: 100 }}>
        <div style={{ fontFamily: "'Syne',sans-serif", fontWeight: 800, fontSize: "18px", display: "flex", alignItems: "center", gap: "8px" }}>
          <span style={{ width: 7, height: 7, background: S.purple, borderRadius: "50%", display: "inline-block", animation: "pulse 2s infinite" }} />
          Clone Yourself
          <span style={{ fontSize: "11px", color: S.muted, fontFamily: "monospace", marginLeft: "4px" }}>by Regovix</span>
        </div>
        <a href="https://regovix.com.au" style={{ fontSize: "12px", color: S.muted, textDecoration: "none", marginLeft: "16px" }}>← Regovix</a>
        <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: "12px" }}>
          <button onClick={logout} style={{ fontSize: "11px", color: S.muted, background: "none", border: "none", cursor: "pointer", fontFamily: "monospace" }}>Lock</button>
          <div style={{ display: "flex", alignItems: "center", gap: "6px", padding: "4px 12px", borderRadius: "20px", background: S.purpleDim, border: "1px solid " + S.purpleBorder, color: S.purple, fontFamily: "monospace", fontSize: "11px" }}>
            <span style={{ width: 5, height: 5, background: S.purple, borderRadius: "50%", animation: "pulse 1.5s infinite" }} />
            AI Video Clone
          </div>
        </div>
      </div>

      <div style={{ maxWidth: "1100px", margin: "0 auto", padding: "36px 24px" }}>
        <div style={{ fontFamily: "'Syne',sans-serif", fontSize: "28px", fontWeight: 800, marginBottom: "6px" }}>Clone Yourself</div>
        <div style={{ fontSize: "14px", color: S.muted, marginBottom: "24px", lineHeight: 1.7 }}>
          Your AI video twin — powered by your knowledge. Start a live session and let your clone speak for you.
        </div>
        <div style={{ background: S.purpleDim, border: "1px solid " + S.purpleBorder, borderRadius: "8px", padding: "12px 14px", fontSize: "12px", color: S.muted, lineHeight: 1.7, marginBottom: "20px" }}>
          ℹ Upload documents in the <a href={BASE_URL + "/twincore.html"} style={{ color: S.purple }}>Knowledge Engine</a> first — your clone answers from your indexed documents via Claude AI. Use the RAG Query panel for document-specific answers.
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 380px", gap: "24px" }}>
          {/* Avatar Panel */}
          <div ref={avatarPanelRef} style={{ background: S.card, border: "1px solid " + S.border, borderRadius: "12px", overflow: "hidden", position: "relative", minHeight: "500px" }}>
            {overlayVisible && (
              <div style={{ position: "absolute", inset: 0, background: "rgba(7,11,18,0.97)", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "14px", textAlign: "center", padding: "24px", zIndex: 5, borderRadius: "12px" }}>
                {overlayContent.spinner
                  ? <div style={{ width: 36, height: 36, border: "3px solid " + S.purpleDim, borderTopColor: S.purple, borderRadius: "50%", animation: "spin 0.8s linear infinite" }} />
                  : <div style={{ fontSize: "48px" }}>{overlayContent.icon}</div>}
                <div style={{ fontFamily: "'Syne',sans-serif", fontSize: "18px", color: S.text }}>{overlayContent.title}</div>
                <div style={{ fontSize: "12px", color: S.muted, maxWidth: "220px", lineHeight: 1.7 }}>{overlayContent.sub}</div>
              </div>
            )}
            <div style={{ position: "absolute", top: "12px", right: "12px", display: "flex", alignItems: "center", gap: "6px", background: "rgba(7,11,18,0.85)", border: "1px solid " + S.border, padding: "4px 10px", borderRadius: "20px", fontFamily: "monospace", fontSize: "11px", color: S.muted, zIndex: 10 }}>
              <span style={{ width: 6, height: 6, borderRadius: "50%", background: statusDotColor[status] || S.muted }} />
              {statusText}
            </div>
            <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, background: "linear-gradient(transparent, rgba(7,11,18,0.9))", padding: "20px 16px 16px", pointerEvents: "none", zIndex: 10 }}>
              <div style={{ fontFamily: "'Syne',sans-serif", fontSize: "16px", fontWeight: 700 }}>Madhu</div>
              <div style={{ fontSize: "12px", color: S.muted }}>CEO · Regovix · AI Clone</div>
            </div>
          </div>

          {/* Controls */}
          <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            <Card title="Session Controls" sub="Start your AI video clone session.">
              <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "12px" }}>
                <span style={{ width: 8, height: 8, borderRadius: "50%", background: statusDotColor[status] || S.muted }} />
                <span style={{ fontFamily: "monospace", fontSize: "11px", color: S.muted }}>{statusText}</span>
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <Btn onClick={startSession} disabled={isActive}>🧬 Start Clone Session</Btn>
                <Btn onClick={stopSession} disabled={!isActive} danger>■ End Session</Btn>
              </div>
            </Card>

            <Card title="RAG Query" sub="Ask anything from your uploaded documents via Claude AI.">
              <div style={{ display: "flex", gap: "6px", flexWrap: "wrap", marginBottom: "10px" }}>
                {["About me", "My expertise", "My services"].map(label => (
                  <button key={label} onClick={() => setQuery("Tell me about " + label.toLowerCase())}
                    style={{ fontSize: "11px", padding: "5px 10px", background: "none", border: "1px solid " + S.border, borderRadius: "6px", color: S.muted, cursor: "pointer", fontFamily: "inherit" }}>
                    {label}
                  </button>
                ))}
              </div>
              <textarea value={query} onChange={e => setQuery(e.target.value)}
                onKeyDown={e => { if (e.key === "Enter" && (e.metaKey || e.ctrlKey)) askQuestion(); }}
                placeholder="Ask your clone anything covered by your uploaded documents..."
                style={{ width: "100%", background: S.bg, border: "1px solid " + S.border, borderRadius: "8px", padding: "12px", color: S.text, fontSize: "14px", resize: "vertical", minHeight: "72px", marginBottom: "10px", outline: "none", fontFamily: "inherit" }} />
              <Btn onClick={askQuestion} disabled={isAsking}>{isAsking ? "Thinking..." : "Ask Clone"}</Btn>
            </Card>

            <Card title="Conversation">
              <div style={{ display: "flex", flexDirection: "column", gap: "10px", maxHeight: "200px", overflowY: "auto" }}>
                {chatLog.length === 0
                  ? <div style={{ textAlign: "center", padding: "20px", color: S.muted, fontSize: "13px" }}>Answers from your documents appear here.</div>
                  : chatLog.map(msg => (
                    <div key={msg.id} style={{ display: "flex", flexDirection: "column", alignItems: msg.role === "user" ? "flex-end" : "flex-start" }}>
                      <div style={{ fontFamily: "monospace", fontSize: "10px", color: S.muted, marginBottom: "4px" }}>{msg.role === "user" ? "YOU" : "CLONE"}</div>
                      <div style={{ maxWidth: "95%", padding: "10px 14px", borderRadius: "8px", fontSize: "13px", lineHeight: 1.6, background: msg.role === "user" ? S.cyanDim : S.card, border: "1px solid " + (msg.role === "user" ? S.cyanBorder : S.border) }}>
                        {msg.text}
                      </div>
                    </div>
                  ))}
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}
